import React, { Component } from "react"
import css from "./Image.module.scss"

class Image extends Component {
  render() {
    return <img className={css.image} alt={this.props.alt} src={this.props.src + "?h=800&q=75"}></img>
  }
}
export default Image
